module.exports = __webpack_public_path__ + "static/media/group3.79aa1b2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group3.svg
// module id = 1356
// module chunks = 0